import { AnchoringWindowIcon } from './assets/icons/anchoringWindow';
import { ManoeuvreBoardIcon } from './assets/icons/manoeuvreBoard';
import { OperationIcon } from './assets/icons/operation';
import { ReportIcon } from './assets/icons/reports';
import { SettingsIcon } from './assets/icons/settings';
import { StaymentManagementIcon } from './assets/icons/staymentManagement';
import { StopoverScheduleIcon } from './assets/icons/stopoverSchedule';
import { StorageTerminalIcon } from './assets/icons/storageTerminalIcon';
import { SideNavbarItensType } from './types';

// Visibility is derived from the user's accessible sections (see useSectionAccess
// + SideNavbar): each leaf `key` is a route path mapped to a section. This list
// only describes the menu's structure.
export const sideNavbarItens: SideNavbarItensType[] = [
  { title: 'Painel', key: '/dashboard', icon: ReportIcon },
  { title: 'Escalas', key: '/stopover-management', icon: StopoverScheduleIcon },
  {
    title: 'Atracações',
    key: '/stayment-management',
    icon: StaymentManagementIcon,
  },
  {
    title: 'Área do Agente',
    key: '/agent-area',
    icon: StopoverScheduleIcon,
  },
  {
    title: 'Janela de atracação',
    key: '/docking-window',
    icon: AnchoringWindowIcon,
  },
  {
    title: 'Quadro de manobras',
    key: '/manoeuvre-board',
    icon: ManoeuvreBoardIcon,
  },
  {
    title: 'Armazenamento',
    key: '/warehousing',
    icon: StopoverScheduleIcon,
    subItens: [
      { title: 'Pátio de veículos', key: '/warehousing/vehicles' },
      {
        title: 'Leitura de notas fiscais',
        key: '/warehousing/reading-invoices',
      },
      {
        title: 'Área do operador de Pátio',
        key: '/warehousing/vehicles/operator-area-warehousing',
      },
    ],
  },
  {
    title: 'Terminais de Armazenamento',
    key: '/warehousing/storage-terminal',
    icon: StorageTerminalIcon,
  },
  {
    title: 'Janela de bombeios',
    key: '/pump-window',
    icon: AnchoringWindowIcon,
  },
  {
    title: 'Área do Operador',
    key: '/operator-area',
    icon: OperationIcon,
  },
  {
    title: 'Faturamento',
    key: '/invoicing',
    icon: StopoverScheduleIcon,
  },
  {
    title: 'Relatórios',
    key: '/reports',
    icon: ReportIcon,
  },
  {
    title: 'Configurações',
    key: '/settings',
    icon: SettingsIcon,
    subItens: [
      { title: 'Usuários e permissões', key: '/settings/permissions' },
      { title: 'Cadastros', key: '/settings/registers' },
      // key COM barra inicial: aqui o key é o path da rota.
      { title: 'Saúde das integrações', key: '/settings/integrations' },
      { title: 'Segurança da Conta', key: '/settings/security' },
    ],
  },
  // {
  //   title: 'Operações',
  //   key: '/operations',
  //   icon: OperationIcon,
  // },
];
